/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Link } from 'react-router-dom'
import { FaFacebookSquare, FaTiktok } from "react-icons/fa"
import { FaSquareInstagram, } from "react-icons/fa6"
import { FaSquarePhoneFlip, FaLocationDot } from "react-icons/fa6"
import { MdMarkEmailUnread } from "react-icons/md"
import utils from '../../utils'

function Footer() {
    const currentDate = new Date()
    
    const quickLinks = [
        { label: 'Home', to: '/' },
        { label: 'Browse Houses', to: '/houses' },
        { label: 'Services & Events', to: '/services' },
        { label: 'Contact', to: '/contact' }
    ]

    const services = [
        { label: 'Corporate Stays', to: '/services' },
        { label: 'Event Spaces', to: '/services' },
        { label: 'Concierge', to: '/services' },
        { label: 'Long Term Rentals', to: '/houses' }
    ]

    return (
        <footer className="bg-brand-bg text-brand-text mt-24 border-t border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-12 px-6 md:px-12 py-16 w-full max-w-7xl mx-auto">
                
                <div className="flex flex-col gap-6">
                    <Link to="/" className="text-2xl font-serif uppercase font-bold text-[#0F1715] tracking-tight hover:opacity-80 transition-opacity">
                        {utils.siteName}
                    </Link>
                    <p className="text-sm font-sans leading-relaxed text-brand-muted">
                        Redefining luxury living in the heart of Kisumu. We provide spaces that inspire and hospitality that anchors.
                    </p>
                </div>

                <div>
                    <h4 className="font-bold uppercase tracking-widest text-xs mb-8 text-[#0F1715]">Quick Links</h4>
                    <ul className="flex flex-col gap-4 text-sm text-brand-muted">
                        {quickLinks.map((link) => (
                            <li key={link.to}>
                                <Link 
                                    to={link.to} 
                                    className="hover:text-orange-500 transition-colors duration-200"
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <h4 className="font-bold uppercase tracking-widest text-xs mb-8 text-[#0F1715]">Services</h4>
                    <ul className="flex flex-col gap-4 text-sm text-brand-muted">
                        {services.map((service) => (
                            <li key={service.label}>
                                <Link 
                                    to={service.to} 
                                    className="hover:text-orange-500 transition-colors duration-200"
                                >
                                    {service.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Contact */}
                <div>
                    <h4 className="font-bold uppercase tracking-widest text-xs mb-8 text-[#0F1715]">Contact</h4>
                    <ul className="flex flex-col gap-4 text-sm text-brand-muted">
                        <li className="flex items-start gap-3">
                            <FaLocationDot className="text-orange-500 mt-1 flex-shrink-0" />
                            <span>Milimani Estate, Kisumu, Kenya</span>
                        </li>
                        <li className="flex items-center gap-3">
                            <MdMarkEmailUnread className="text-orange-500 flex-shrink-0" />
                            <a href="mailto:sagefurnishedapartments@gmail.com" className="hover:text-orange-500 transition-colors">
                                sagefurnishedapartments@gmail.com
                            </a>
                        </li>
                        <li className="flex items-center gap-3">
                            <FaSquarePhoneFlip className="text-orange-500 flex-shrink-0" />
                            <a href="tel:+254711610000" className="hover:text-orange-500 transition-colors">
                                +254 711 610 000
                            </a>
                        </li>
                    </ul>

                    {/* Social Icons */}
                    <div className="flex gap-4 mt-8">
                        <a href="#" className="text-brand-muted hover:text-orange-500 transition-colors text-xl">
                            <FaSquareInstagram />
                        </a>
                        <a href="#" className="text-brand-muted hover:text-orange-500 transition-colors text-xl">
                            <FaFacebookSquare />
                        </a>
                        <a href="#" className="text-brand-muted hover:text-orange-500 transition-colors text-xl">
                            <FaTiktok />
                        </a>
                    </div>
                </div>
            </div>
            <div className="border-t border-brand-border py-8 px-6 text-center">
                <p className="text-xs tracking-wide text-brand-muted">
                    © {currentDate.getFullYear()} Sage Apartments. Accepting M-Pesa, Cash & Direct Bank Transfer.
                </p>
            </div>
        </footer>
    )
}

export default Footer